import axios from 'axios';
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';
import {appendFiltersToFormData} from '@/helpers/employeesHelper';
import {userPermissionsList} from '@/constants/userPermissions';

const api_url = '/index.php';

export default {
    namespaced: true,

    state: {
        columns: [],

        records: [],

        userColumns: [],

        referenceFilterList: [],

        actionStatus: null,

        allFilters: [],

        userFilters: [],

        saveUserFilters: [],

        infoAboutUserEmployee: null,

        totalRecordsCount: 0,
    },

    mutations: {
        setReferenceValues(state, referenceFilterList) {
            state.referenceFilterList = referenceFilterList;
        },

        setColumns(state, columns) {
            state.columns = columns;
        },

        setUserColumns(state, columns) {
            state.userColumns = columns;
        },

        setRecords(state, records) {
            state.records = records;
        },

        setActionStatus(state, actionStatus) {
            state.actionStatus = actionStatus;
        },

        setAllFilters(state, allFilters) {
            state.allFilters = allFilters;
        },

        setUserFilters(state, userFilters) {
            state.userFilters = userFilters;
        },

        setSaveUserFilters(state, saveUserFilters) {
            state.saveUserFilters = saveUserFilters;
        },

        setInfoAboutUserEmployee(state, infoAboutUserEmployee) {
            state.infoAboutUserEmployee = infoAboutUserEmployee;
        },
        setTotalRecordsCount(state, count) {
            state.totalRecordsCount = count;
        },
    },

    getters: {
        getUserColumns(state) {
            return state.userColumns;
        },

        getColumns(state) {
            return state.columns;
        },

        getRecords(state) {
            return state.records;
        },

        getActionStatus(state) {
            return state.actionStatus;
        },

        getReferenceValues(state) {
            return state.referenceFilterList;
        },

        getAllFilters(state) {
            return state.allFilters;
        },

        getUserFilters(state) {
            return state.userFilters;
        },

        getSaveUserFilters(state) {
            return state.saveUserFilters;
        },

        getInfoAboutUserEmployee(state) {
            return state.infoAboutUserEmployee;
        },
        isAllowedForMapTab(state, getters, rootState, rootGetters) {
            let firstPermission = false;
            let secondPermission = false;

            const userPermissions = rootState.userPermissions;

            const workerPermissions = [
                userPermissionsList.worker.viewAll,
                userPermissionsList.worker.viewOwn,
                userPermissionsList.worker.controlAll,
                userPermissionsList.worker.controlOwn,
            ];
            const worksheetPermissions = [
                userPermissionsList.worker.worksheet.view,
                userPermissionsList.worker.worksheet.control,
            ];
            userPermissions.forEach(permission => {
                if (workerPermissions.includes(permission)) {
                    firstPermission = true;
                }
                if (worksheetPermissions.includes(permission)) {
                    secondPermission = true;
                }
            });

            return firstPermission && secondPermission;
        },
        isAllowedToWorkerSummaryData(state, getters, rootState, rootGetters) {
            const userPermissions = rootState.userPermissions;

            return userPermissions.includes(
                userPermissionsList.worker.viewSummaryData);
        },
        getTotalRecordsCount: (state) => state.totalRecordsCount,
    },

    actions: {
        async getColumns(ctx) {
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker/columns`, token));

            const json = await res.json();

            ctx.commit('setColumns', json.columns);
        },

        async getUserColumns(ctx) {
            const {userId} = ctx.rootState;
            const token = ctx.rootState.authToken;

            const res = await fetch(addAuthKey(
                `${api_url}/?r=api/worker/user-columns&user_id=${userId}`,
                token));

            const json = await res.json();

            ctx.commit('setUserColumns', json.columns);
        },

        async saveUserColumns(ctx, columns) {
            const {userId} = ctx.rootState;
            const token = ctx.rootState.authToken;

            const form_data = new FormData();

            form_data.append('columns', JSON.stringify(columns));
            form_data.append('user_id', userId);

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker/save-user-columns`, token),
                {
                    method: 'post',
                    body: form_data,
                });

            const json = await res.json();

            if (json.response) {
                ctx.commit('setUserColumns', columns);
            }
            return columns;
        },

        async getRecords(ctx, params) {
            const token = ctx.rootState.authToken;
            const {userId} = ctx.rootState;

            const form_data = new FormData();
            const page = params[0];
            const sort_by = params[1];
            const sort_type = params[2];
            const globalFilters = [...params[3].globalFilters];
            const localFilters = [...params[3].localFilters];
            const isExport = (params[4] === undefined) ? 0 : params[4];
            const tab = (params[5] === undefined) ? 'list' : params[5];

            if (globalFilters.length > 0 || localFilters.length > 0) {
                appendFiltersToFormData(localFilters, 'col_filters', form_data);
                appendFiltersToFormData(globalFilters, 'filters', form_data);
            }

            const res = await fetch(addAuthKey(
                `${api_url}/?r=api/worker/workers&user_id=${userId}&sort_by=${sort_by}&sort_type=${sort_type}&page=${page}&is_export=${isExport}&tab=${tab}`,
                token), {
                method: 'post',
                body: form_data,
            });

            const json = await res.json();

            if (!isExport)
                ctx.commit('setTotalRecordsCount', json.total_count);

            if (isExport !== 1) {
                ctx.commit('setRecords', json.workers);
            } else {
                ctx.commit('setRecords', 'isExportExcel');
            }

            return json;
        },

        async removeWorker(ctx, worker_id) {
            const token = ctx.rootState.authToken;

            const res = await fetch(addAuthKey(
                `${api_url}/?r=api/worker/remove-worker&worker_id=${worker_id}`,
                token));

            const json = await res.json();

            ctx.commit('setActionStatus', json);
        },

        async getReferenceValues(ctx, columnId) {
            const token = ctx.rootState.authToken;

            const res = await fetch(addAuthKey(
                `${api_url}/?r=api/worker/filter-data&filter_column=${columnId}`,
                token));

            const json = await res.json();

            ctx.commit('setReferenceValues', json);

            return json;
        },

        async getAllFilters(ctx) {
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker/filters`, token));

            const json = await res.json();

            ctx.commit('setAllFilters', json);

            return json;
        },

        async getUserFilters(ctx) {
            const {userId} = ctx.rootState;
            const token = ctx.rootState.authToken;

            const res = await fetch(addAuthKey(
                `${api_url}/?r=api/worker/user-filters&user_id=${userId}`,
                token));

            const json = await res.json();

            ctx.commit('setUserFilters', json);
        },

        async saveUserFilters(ctx, filters) {
            const {userId} = ctx.rootState;
            const token = ctx.rootState.authToken;

            const form_data = new FormData();

            form_data.append('filters', JSON.stringify(filters));
            form_data.append('user_id', userId);

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker/save-user-filters`, token),
                {
                    method: 'post',
                    body: form_data,
                });

            const json = await res.json();

            if (json.response) {
                ctx.commit('setUserFilters', filters);
            }
        },

        async getInfoAboutUserEmployee(ctx, workerId) {
            const token = ctx.rootState.authToken;

            const res = await fetch(addAuthKey(
                `${api_url}/?r=api/worker/user-status&worker_id=${workerId}`,
                token));

            const json = await res.json();

            ctx.commit('setInfoAboutUserEmployee', json);

            return json;
        },

        async blockUserEmployee(ctx, workerId) {
            const token = ctx.rootState.authToken;

            const res = await fetch(addAuthKey(
                `${api_url}/?r=api/worker/change-user-status&worker_id=${workerId}&action=block`,
                token));

            const json = await res.json();

            return json;
        },

        async unblockUserEmployee(ctx, workerId) {
            const token = ctx.rootState.authToken;

            const res = await fetch(addAuthKey(
                `${api_url}/?r=api/worker/change-user-status&worker_id=${workerId}&action=unblock`,
                token));

            const json = await res.json();

            return json;
        },

        async createUserForEmployee(ctx, params) {
            const token = ctx.rootState.authToken;

            const formData = new FormData();

            Object.entries(params).forEach(([key, value]) => {
                if (value) formData.append(`NewUserForm[${key}]`, value);
            });

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker/create-new-user`, token), {
                    method: 'post',
                    body: formData,
                });

            const json = await res.json();

            return json;
        },

        async getWorkerStatus(ctx, workerId) {
            const token = ctx.rootState.authToken;

            const res = await fetch(addAuthKey(
                `${api_url}/?r=api/worker/worker-job-status&worker_id=${workerId}`,
                token));

            const json = await res.json();

            return json;
        },

        async getDismissReasons(ctx) {
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker/dismiss-reasons`, token));

            const json = await res.json();

            return json;
        },

        async changeEmployeeStatus(ctx, params) {
            const {userId} = ctx.rootState;
            const token = ctx.rootState.authToken;
            const form_data = new FormData();
            const {workerId} = params;
            const {statusId} = params;
            const dismissId = (params.dismissId !== undefined) ?
                params.dismissId :
                undefined;
            const desc = (params.desc !== undefined) ? params.desc : undefined;

            form_data.append('worker_id', workerId);
            form_data.append('status_id', statusId);
            if (dismissId !== undefined) {
                form_data.append('dismiss_id', dismissId);
            }
            if (desc !== undefined) {
                form_data.append('desc', desc);
            }

            const res = await fetch(addAuthKey(
                `${api_url}/?r=api/worker/change-worker-status&user_id=${userId}`,
                token), {
                method: 'post',
                body: form_data,
            });

            const json = await res.json();

            return json;
        },

        async getInfoAboutFavoritesReports(ctx) {
            const {userId} = ctx.rootState;
            const token = ctx.rootState.authToken;

            const res = await fetch(addAuthKey(
                `${api_url}/?r=api/worker/user-chart-settings&user_id=${userId}`,
                token));

            const json = await res.json();

            return json;
        },

        async addOrRemoveReportToFavorites(ctx, params) {
            const {userId} = ctx.rootState;
            const token = ctx.rootState.authToken;
            const {chartName} = params;
            const {chartStatus} = params;

            const res = await fetch(addAuthKey(
                `${api_url}/?r=api/worker/add-chart-to-favorites&chart_name=${chartName}&chart_status=${chartStatus}&user_id=${userId}`,
                token));

            const json = await res.json();

            return json;
        },
        getWorkersWithAddress({rootState}, params) {
            const token = rootState.authToken;
            const {userId} = rootState;

            const form_data = new FormData();
            const sort_by = params[1];
            const sort_type = params[2];
            const globalFilters = [...params[3].globalFilters];
            const localFilters = [...params[3].localFilters];

            if (globalFilters.length > 0 || localFilters.length > 0) {
                appendFiltersToFormData(globalFilters, 'filters', form_data);
            }

            const url = addAuthKey(
                `${api_url}/?r=api/worker/map&user_id=${userId}&sort_by=${sort_by}&sort_type=${sort_type}`,
                token);

            return axios.post(url, form_data);
        },
        getSummaryData({rootState}, params) {
            const form_data = new FormData();
            const globalFilters = [...params[0].globalFilters];
            const localFilters = [...params[0].localFilters];
            const token = rootState.authToken;
            const {userId} = rootState;
            if (globalFilters.length > 0 || localFilters.length > 0) {
                appendFiltersToFormData(localFilters, 'col_filters', form_data);
                appendFiltersToFormData(globalFilters, 'filters', form_data);
            }
            const url = addAuthKey(`${api_url}?r=api/worker/summary-data`,
                token);

            return axios.post(url, form_data);
        },

        async generateLogin(ctx, id) {
            const token = ctx.rootState.authToken;

            const res = await fetch(addAuthKey(
                `${api_url}/?r=api/worker/generate-login&worker_id=${id}`,
                token));

            const json = await res.json();

            return json;
        },

        getWorkersBonuses({rootState}, params) {
            const token = rootState.authToken;

            const url = addAuthKey(`${api_url}/?r=api/calculation/bonus-range`,
                token);

            return axios.post(url, params);
        },
    },
};
